import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

// import FeaturedEvents from "../../components/ui/FeaturedEvents";
import ResearchCTA from "../../components/ui/ResearchCTA";

import IQACMission from "../../components/CenterOfExcellence/IQACMission";
import ImageHeading from "../../components/ui/ImageHeading";

import bannerImage from "../../assets/centers/edrc_11zon.jpg";
// import PublicationCarousel from "../../components/CenterOfExcellence/PublicationCarousel";
import LoadingPage from "../../components/Layout/LoadingPage";
import useAxiosPublic from "../../hooks/useAxiosPublic";
import { useQuery } from "@tanstack/react-query";
import CoreValues from "../../components/CenterOfExcellence/CoreValues";
// import TeamCarousel from "../../components/CenterOfExcellence/TeamCarousel";

const EDRC = () => {
  const axiosPublic = useAxiosPublic();

  const {
    data: edrcApiData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["edrcApi"],
    queryFn: async () => {
      const res = await axiosPublic.get("/centers/edrc");
      return res?.data?.data?.edrc;
    },
  });

  if (isLoading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <div className="text-center py-20 text-red-500">Error loading data</div>
    );
  }

  return (
    <div>
      <ImageHeading
        heading="Entrepreneur Development Research Center (EDRC)"
        imageUrl={bannerImage}
      />
      <div className="container px-4 mx-auto md:px-8 lg:px-0 ">
        <div className="gap-8 my-12 ">
          <div>
            <div>
              <h3 className="text-2xl font-bold mb-4  text-black lg:text-4xl font-domine">
                {edrcApiData?.title}
              </h3>

              <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                {edrcApiData?.description}
              </ReactMarkdown>
            </div>

            <IQACMission
              title={edrcApiData?.what_we_do?.title}
              details={edrcApiData?.what_we_do?.description}
              data={edrcApiData?.what_we_do?.points}
            />
            <CoreValues
              data={edrcApiData?.core_values}
              title={edrcApiData?.core_values?.title}
            />

            <div className="py-12 space-y-20">
              {/* <PublicationCarousel
                data={edrcApiData?.publication_with_urls?.publication_list}
                title={"Publication & Report"}
              /> */}

              {/* <TeamCarousel title={"   EDRC Team"} /> */}
              {/* <FeaturedEvents /> */}
              <ResearchCTA
                title={edrcApiData?.contact?.title}
                mail={edrcApiData?.contact?.email}
                number={edrcApiData?.contact?.phone}
                description={edrcApiData?.contact?.description}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EDRC;
